import React, { Component } from 'react';
import { connect } from 'react-redux';
import Autocomplete from 'react-autocomplete';
import moment from 'moment';
import { FadeLoader } from 'react-spinners';
import getEspecialista from '../../utils/getEspecialista';
import getCorteProgramacion from '../../utils/getCorteProgramacion';


import {
  fetchEstadoGeneralTransp,
  fetchEstadoGeneralLugarEntrega,
  fetchEstadoGeneralTipoEntrega,
  entregaFilial,
  fetchColaboradores,
  clearColaboradores,
  programarPlanificacion,
  reProgramarPlanificacion,
  personasAdicionales,
  listarProgramacionXsede,
  programacionCalendario,
  dias_traslado
 } from '../../actions';

import Calendar from '../Calendar';
import { isNull } from 'util';

/* eslint-disable no-useless-escape*/
const emailRegEx = /^(([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+)(([\s]*[;,]+[\s]*(([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+))*)$/;

class ModalReProgramacion extends Component {
  static hideMessage() {
    document.getElementById('ModalreProgramacionMessages').style.display = 'flex';
    setTimeout(() => {
      if (document.getElementById('ModalreProgramacionMessages')) {
        document.getElementById('ModalreProgramacionMessages').style.display = 'none';
      }
    }, 3000);
  }

  constructor(props) {
    super(props);
    this.state = this.getInitialState();


    this.handleChangeModalClose = this.handleChangeModalClose.bind(this);
    this.onClickPreviousPage = this.onClickPreviousPage.bind(this);
    this.onClickPreviousPage = this.onClickPreviousPage.bind(this);
    this.onClickNextPage = this.onClickNextPage.bind(this);
    this.changeLugarEntrega = this.changeLugarEntrega.bind(this);
    this.onClickConfirmar = this.onClickConfirmar.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.selectHandleChange = this.selectHandleChange.bind(this);
    this.selectHandleChangeOption = this.selectHandleChangeOption.bind(this);
    this.handleClickValCalendar = this.handleClickValCalendar.bind(this);
    this.handleClickValFrom = this.handleClickValFrom.bind(this);
    this.updateParent = this.updateParent.bind(this);
    this.back = this.back.bind(this);
    this.next = this.next.bind(this);
    this.today = this.today.bind(this);
    this.onClickbtnConfirmar = this.onClickbtnConfirmar.bind(this);
    this.onClickbtnNext = this.onClickbtnNext.bind(this);
    this.renderCalendar = this.renderCalendar.bind(this);
    this.loadCalendarPlanificacion = this.loadCalendarPlanificacion.bind(this);
    this.onClickComenzar = this.onClickComenzar.bind(this);
  }

  getInitialState = () => {
    const initialState = {
      estadoStep: 0,
      valueLugar: '2',
      statusFrom: true,
      fromEntrega: {
        codFilial: '',
        labelcodLugEntrega: '',
        codLugEntrega: '',
        codTransp: '',
        labelcodTransp: '',
        codUsuResp: '',
        dirContacto: '',
        emaContacto: '',
        fecProgramada: '',
        invitacionCal: '',
        nomContacto: '',
        obsContacto: '',
        personalAd: [],
        listaPerAd: [],
        listItemsUsu: [],
        telContacto: '',
        tipPlaca: '1',
        codEntrega: '',
        labelcodEntrega: '',
        codPlanEntrVehi: '',
        numHorEntr: '1',
        emaContConfi: '',
        fecComercialReprog: '',
      },
      btnconfirmar: 'none',
      itempersonalAd: '',
      itemcodUsuResp: '',
      muestraLoad: 'none',
      listItemsPe: [],
      listItemsUsu: !this.props.datafromEntrega.listItemsUsu ? [] : this.props.datafromEntrega.listItemsUsu,
      listaFromEntrega: [],
      validarCampo: false,
      validaEmail: false,
      validaEmailConf: false,
      trueComplete: true,
      selected: '',
      messageShow: 'none',
      classMessage: '',
      classMessageIcon: '',
      mensajeAlert: '',
      weekday: moment().weekday(),
      currentWeek: moment().isoWeek(),
      disponibilidad: !this.props.FEdisponibilidad ? [] : this.props.FEdisponibilidad,
      eventsBlocked: !this.props.dataProgramar ? [] : this.props.dataProgramar,
      currentEvent: [],
      diasTraslado: '',
      infoCalendario: '',
      lstAdicionales: [],
      valueRenderCalendar: false,
      currentSetYear:moment().format('YYYY'),
      tipoReprogramacion:'',
      validaFecha: false,
      valueHoraCorte:'',
    };
    return initialState;
  }

  resetState = () => {
    this.setState(this.getInitialState());
  }

  componentDidMount() {
    this.props.fetchEstadoGeneralTransp();
    this.props.fetchEstadoGeneralLugarEntrega();
    this.props.entregaFilial();




        // this.setState({
    //   eventsBlocked: this.state.eventsBlocked,
    //   currentEvent: this.state.currentEvent });
    // this.props.listarProgramacionXsede();
  }


  componentWillReceiveProps(props) {

  }


  updateParent(nuevoEvento, eventos,fecha) {
    this.setState({
      newProgramacion: `${nuevoEvento[0].date} ${nuevoEvento[0].from}`,
      currentEvent: nuevoEvento,
      eventsBlocked: eventos,
      validaFecha: fecha,
    });
  }

  loadCalendarPlanificacion(filial,opcion) {
    this.setState({ muestraLoad: 'block' });

    // validar semana por fechas

    let date = moment(this.state.currentSetYear).format('YYYY');
    let varyear = moment({year: date});
    let currentWeek = this.state.currentWeek; // numero de semana del año
   if(opcion === 1 ){
       currentWeek = currentWeek - 1;
      if( currentWeek === 0){
        varyear =  moment({year: date -1 });
        this.setState({ currentWeek: 52, eventsBlocked: [], currentSetYear: varyear });
      }else{
        this.setState({ currentWeek: this.state.currentWeek - 1, eventsBlocked: [] });
      }
    }else if(opcion === 2 ){
      currentWeek = currentWeek + 1;

      if( currentWeek === 53){
        varyear =moment({year: +date + 1 });
        this.setState({ currentWeek: 1, eventsBlocked: [], currentSetYear:varyear });
      }else{
        this.setState({ currentWeek: this.state.currentWeek + 1, eventsBlocked: [] });
      }
    }else if(opcion === 3 ){
       currentWeek = moment().isoWeek();
      let datehoy = moment().format('YYYY');
      varyear  = moment({year: datehoy });
      this.setState({ currentWeek: moment().isoWeek(), eventsBlocked: [], currentSetYear: varyear});
    }

    const castDate = moment({year: moment(varyear).format('YYYY'), month: 1, day: 1, hour: 0});
    //const weekday = moment().weekday();
    const arraydate = [];
    console.log('currentSetYear :'+ moment(castDate).format('DD/MM/YYYY'));

    const startOfWeek = moment(castDate).isoWeek(currentWeek).startOf('isoWeek');
    const endOfWeek = moment(castDate).isoWeek(currentWeek).endOf('isoWeek');
    let day = startOfWeek;

    while (day <= endOfWeek) {
      arraydate.push(moment(day.toDate()).format('DD/MM/YYYY'));
      day = day.clone().add(1, 'd');
    }


    const promises = [];
    const lista = [];
    promises.push(this.props.listarProgramacionXsede('PR', filial, arraydate[0], arraydate[6]));
    Promise.all(promises)
    .then((results) => {
      if (results[0].payload.data.estadoTrama === '1') {
        results[0].payload.data.entrega.forEach((entry) => {
          const lispedido = [];
          lispedido.push({ numPedi: entry.numPedidoVeh, chasis: entry.numChasis });
          const obj = {};
          obj.codPlanEntrVehi = entry.codPlanEntrVehi;
          obj.nomEmpresa = entry.desCliente;
          obj.fechProinicio = moment(entry.fecProgramada).format('DD/MM/YYYY HH:mm');
          obj.fechProfin = moment(entry.fecProgramada).add(entry.numHorEntr, 'hours').format('DD/MM/YYYY HH:mm');
          obj.pedidos = lispedido;
          lista.push(obj);
        });
      } else if (results[0].payload.data.estadoTrama === '-1') {
        this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: '¡Error inesperado, interno del servidor!', classMessage: 'alert-danger', classMessageIcon: '' });
        ModalReProgramacion.hideMessage();
      } else {
        this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: '¡Error interno del servidor!', classMessage: 'alert-danger', classMessageIcon: '' });
        ModalReProgramacion.hideMessage();
      }
    }).then(() => this.setState({ muestraLoad: 'none', eventsBlocked: lista })).catch(() => {
      this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: '¡Error interno del servidor!', classMessage: 'alert-danger', classMessageIcon: '' });
      ModalReProgramacion.hideMessage();
    });
  }


  back() {

     if (this.state.fromEntrega.codLugEntrega === '1') {
      this.loadCalendarPlanificacion(this.state.fromEntrega.codFilial,1);
    } else {
      this.loadCalendarPlanificacion('000', 1);
    }
  }

  next() {

    if (this.state.fromEntrega.codLugEntrega === '1') {
      this.loadCalendarPlanificacion(this.state.fromEntrega.codFilial, 2);
    } else {
      this.loadCalendarPlanificacion('000',2);
    }
  }

  today() {

    if (this.state.fromEntrega.codLugEntrega === '1') {
      this.loadCalendarPlanificacion(this.state.fromEntrega.codFilial, 3);
    } else {
      this.loadCalendarPlanificacion('000', 3);
    }
  }

  onClickbtnConfirmar() {
    this.setState({ btnconfirmar: 'none' });
  }

  onClickComenzar() {
    this.setState({ muestraLoad: 'block' });

    this.setState({ listItemsPe: this.props.datafromEntrega.listaPerAd });

    this.setState({ fromEntrega: this.props.datafromEntrega,
      statusFrom: false,
      currentEvent: this.props.currentEvent,
      disponibilidad: this.props.FEdisponibilidad,
      newProgramacion: moment(this.props.datafromEntrega.fecProgramada).format('DD/MM/YYYY HH:mm'),
      currentWeek: moment(this.props.datafromEntrega.fecProgramada).isoWeek(),
      currentSetYear: moment({year: moment(this.props.datafromEntrega.fecProgramada).format('YYYY')}),
    });
    let numero = 0,
      txt = '',
      info = '',
      plural = '';

    if (this.props.FEdisponibilidad !== undefined && this.props.FEdisponibilidad.length > 0) {
      this.props.FEdisponibilidad.forEach((entry) => {
        numero = entry.canMaxiUnidEntr;
        txt = entry.codTipoDiaEntr === 'D' ? 'día' : 'semana';
        plural = entry.canMaxiUnidEntr === '1' ? 'pedido' : 'pedidos';
        info = `Planificación de ${numero} ${plural} por ${txt}.`;
      });
      this.setState({ lstAdicionales: this.props.FEdisponibilidad[0].lstAdicionales });
    }
    const promises = [];

    let valueLugarEntrega = this.props.selectedID[0].codLugEntrega === '2'? this.props.selectedID[0].codLugEntrega : this.props.selectedID[0].codFilial2;

    promises.push(this.props.dias_traslado(
      this.props.selectedID[0].numPedidoVeh,
      this.props.selectedID[0].codCia,
      this.props.selectedID[0].codProv,
      valueLugarEntrega));
    Promise.all(promises)
      .then((results) => {
        this.setState({ diasTraslado: results[0].payload.data.codigo });
      });

    this.setState({ infoCalendario: info, estadoStep: this.state.estadoStep + 1 });



    getCorteProgramacion( this.props.selectedID[0].codAreaVta,'').then((results) => {
      if(results.data.datosMaestros.length > 0){
          this.setState({valueHoraCorte: results.data.datosMaestros[0].valValor});
      }else{
        this.setState({valueHoraCorte: 'false'});
      }
    });




    this.setState({ muestraLoad: 'none' });
  }

  onClickbtnNext() {
    this.setState({ btnconfirmar: 'none' });
    this.setState({ estadoStep: this.state.estadoStep + 1 }, () => this.setState({ eventsBlocked: this.state.eventsBlocked, currentEvent: this.state.currentEvent }));
  }

  onClickPreviousPage() {
    this.setState({ estadoStep: this.state.estadoStep - 1 }, () => this.setState({ eventsBlocked: this.state.eventsBlocked, currentEvent: this.state.currentEvent }));
  }

  onClickNextPage() {

    getEspecialista(this.props.selectedID,this.state.fromEntrega.codFilial,this.state.fromEntrega.codLugEntrega).then((results) => {
      this.setState({ listItemsUsu: results.data.lstUsuarios });
    });

    if (this.state.estadoStep === 1) {
      this.setState({ btnconfirmar: 'block' });
    } else if (this.state.estadoStep === 0 && this.state.fromEntrega.codLugEntrega === '1') {
      this.setState({ muestraLoad: 'block', estadoStep: this.state.estadoStep + 1 });
      const currentWeek = moment(this.props.datafromEntrega.fecProgramada).isoWeek();
     // const weekday = moment().weekday();
      const date = [];

      const castDate = moment({year: moment(this.state.currentSetYear).format('YYYY'), month: 1, day: 1, hour: 0});
      const startOfWeek = moment(castDate).isoWeek(currentWeek).startOf('isoWeek');
      const endOfWeek = moment(castDate).isoWeek(currentWeek).endOf('isoWeek');
      let day = startOfWeek;

      while (day <= endOfWeek) {
        date.push(moment(day.toDate()).format('DD/MM/YYYY'));
        day = day.clone().add(1, 'd');
      }




      const promises = [];
      const lista = [];
      promises.push(this.props.listarProgramacionXsede('PR', this.state.fromEntrega.codFilial, date[0], date[6]));
      Promise.all(promises)
      .then((results) => {
        if (results[0].payload.data.estadoTrama === '1') {
          results[0].payload.data.entrega.forEach((entry) => {
            const lispedido = [];
            lispedido.push({ numPedi: entry.numPedidoVeh, chasis: entry.numChasis });
            const obj = {};
            obj.codPlanEntrVehi = entry.codPlanEntrVehi;
            obj.nomEmpresa = entry.desCliente;
            obj.fechProinicio = moment(entry.fecProgramada).format('DD/MM/YYYY HH:mm');
            obj.fechProfin = moment(entry.fecProgramada).add(entry.numHorEntr, 'hours').format('DD/MM/YYYY HH:mm');
            obj.pedidos = lispedido;
            lista.push(obj);
          });
        } else if (results[0].payload.data.estadoTrama === '-1') {
          this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: '¡Error inesperado, interno del servidor!', classMessage: 'alert-danger', classMessageIcon: '' });
          ModalReProgramacion.hideMessage();
        } else {
          this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: '¡Error interno del servidor!', classMessage: 'alert-danger', classMessageIcon: '' });
          ModalReProgramacion.hideMessage();
        }
      }).then(() => this.setState({ muestraLoad: 'none', eventsBlocked: lista })).catch(() => {
        this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: '¡Error interno del servidor!', classMessage: 'alert-danger', classMessageIcon: '' });
        ModalReProgramacion.hideMessage();
      });
    } else {
      this.setState({ estadoStep: this.state.estadoStep + 1 });
    }
  }

  onClickConfirmar() {
    this.setState({ muestraLoad: 'block' });
    const varPersona = [];
    const promises = [];

    this.state.listItemsPe.map(Rows => (
      varPersona.push(Rows.id)
    ));

    this.props.selectedID.map(
      Rows => (
    promises.push(this.props.reProgramarPlanificacion(
      this.state.fromEntrega,
      varPersona,
      this.state.listItemsUsu[0].id, Rows, this.state.newProgramacion, this.state.disponibilidad[0].numHorasReservada,this.state.tipoReprogramacion))
    ));
    Promise.all(promises)
    .then((results) => {
      if (results[0].payload.data.estadoTrama === '1') {
        this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: results[0].payload.data.mensaje, classMessage: 'alert-success', classMessageIcon: 'ion-checkmark-circled' });
        this.handleChangeModalClose(false);
        ModalReProgramacion.hideMessage();
      } else if (results[0].payload.data.estadoTrama === '0') {
        this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: results[0].payload.data.mensaje, classMessage: 'alert-info', classMessageIcon: 'ion-information-circled' });
        ModalReProgramacion.hideMessage();
      } else if (results[0].payload.data.estadoTrama === '-1') {
        this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: '¡Error inesperado, interno del servidor!', classMessage: 'alert-danger', classMessageIcon: '' });
        ModalReProgramacion.hideMessage();
      } else {
        this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: '¡Error interno del servidor!', classMessage: 'alert-danger', classMessageIcon: '' });
        ModalReProgramacion.hideMessage();
      }
    }).catch(() => {
      this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: '¡Error interno del servidor!', classMessage: 'alert-danger', classMessageIcon: '' });
      ModalReProgramacion.hideMessage();
    });
  }

  handleChange(e) {
    if(e.target.name === 'emaContacto'){
      const setCorreo = this.state.fromEntrega; // creates the clone of the state
      setCorreo.emaContacto = e.target.value;
      this.setState({ fromEntrega: setCorreo });
      if (e.target.value.length > 0) {

        if (!emailRegEx.test(e.target.value)) {
          this.setState({ validaEmail: true});
        } else {
          this.setState({ validaEmail: false });
        }
      }
    }else if(e.target.name === 'emaContConfi'){
      const setCorreoCon = this.state.fromEntrega; // creates the clone of the state
      setCorreoCon.emaContConfi = e.target.value;
      this.setState({ fromEntrega: setCorreoCon });
      if (e.target.value.length > 0) {
        if (!emailRegEx.test(e.target.value)) {
          this.setState({ validaEmailConf: true});
        } else {
          this.setState({ validaEmailConf: false });
        }
      }
    } else if (e.target.name === 'personalAd') {
      this.setState({ itempersonalAd: e.target.value });
    } else {
      const a = this.state.fromEntrega; // creates the clone of the state
      a[e.target.name] = e.target.value;
      this.setState({ fromEntrega: a });

      if (e.target.name === 'codFilial') {


        const currentWeek =  moment().isoWeek();
     //   const weekday = moment().weekday();
        const date = [];

        const startOfWeek = moment().isoWeek(currentWeek).startOf('isoWeek');
        const endOfWeek = moment().isoWeek(currentWeek).endOf('isoWeek');
        const days = [];
        let day = startOfWeek;

        while (day <= endOfWeek) {
          days.push(moment(day.toDate()).format('DD/MM/YYYY'));
          day = day.clone().add(1, 'd');
        }


        this.setState({ muestraLoad: 'block', eventsBlocked: [], disponibilidad: [] });
        const promises = [];
        const lista = [];
        const objDisponibilidad = [];
        const valueFLOTA = this.props.selectedID.length === 1 ? 'N' : 'S';

        promises.push(this.props.listarProgramacionXsede('PR', e.target.value, date[0], date[6]));
        promises.push(this.props.programacionCalendario(e.target.value, this.props.selectedID[0].codFilial, this.props.selectedID[0].codFamiliaVeh, valueFLOTA, this.state.fromEntrega.codLugEntrega));
        promises.push(this.props.dias_traslado(
          this.props.selectedID[0].numPedidoVeh,
          this.props.selectedID[0].codCia,
          this.props.selectedID[0].codProv,
          e.target.value));

        Promise.all(promises)
        .then((results) => {
          if (results[0].payload.data.estadoTrama === '1' &&
          results[1].payload.data.estadoTrama === '1' &&
          results[2].payload.data.estadoTrama === '1') {
            results[0].payload.data.entrega.forEach((entry) => {
              const lispedido = [];
              lispedido.push({ numPedi: entry.numPedidoVeh, chasis: entry.numChasis });
              const obj = {};
              obj.codPlanEntrVehi = entry.codPlanEntrVehi;

              obj.nomEmpresa = entry.desCliente;
              obj.fechProinicio = moment(entry.fecProgramada).format('DD/MM/YYYY HH:mm');
              obj.fechProfin = moment(entry.fecProgramada).add(entry.numHorEntr, 'hours').format('DD/MM/YYYY HH:mm');
              obj.pedidos = lispedido;
              lista.push(obj);
            });

            objDisponibilidad.push(results[1].payload.data.disponibilidad[0]);
            {// set de variables para calendario
              let numero = 0,
                txt = '',
                info = '',
                plural = '';
              this.state.disponibilidad.forEach((entry) => {
                numero = entry.canMaxiUnidEntr;
                txt = entry.codTipoDiaEntr === 'D' ? 'día' : 'semana';
                plural = entry.canMaxiUnidEntr === '1' ? 'pedido' : 'pedidos';
                info = `Planificación de ${numero} ${plural} por ${txt}.`;
              });
              this.setState({ diasTraslado: results[2].payload.data.codigo, infoCalendario: info });
            }
          }
          else if (results[0].payload.data.estadoTrama === '-1' ||
          results[1].payload.data.estadoTrama === '-1' ||
          results[2].payload.data.estadoTrama === '-1') {
            this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: '¡Error inesperado, interno del servidor!', classMessage: 'alert-danger', classMessageIcon: '' });
            ModalReProgramacion.hideMessage();
          } else if( results[1].payload.data.estadoTrama ==='0'){
            this.setState({ infoCalendario: '', muestraLoad: 'none', messageShow: 'block', mensajeAlert: results[1].payload.data.mensaje, classMessage: 'alert-info', classMessageIcon: 'ion-information-circled' });
            ModalReProgramacion.hideMessage();
          } else if( results[2].payload.data.estadoTrama ==='0'){
            this.setState({ infoCalendario: '', muestraLoad: 'none', messageShow: 'block', mensajeAlert: results[1].payload.data.mensaje, classMessage: 'alert-info', classMessageIcon: 'ion-information-circled' });
            ModalReProgramacion.hideMessage();

          } else {
            this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: '¡Error interno del servidor!', classMessage: 'alert-danger', classMessageIcon: '' });
            ModalReProgramacion.hideMessage();
          }
        }).then(() => this.setState({ muestraLoad: 'none', eventsBlocked: lista, disponibilidad: objDisponibilidad })).catch(() => {
           this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: '¡Error interno del servidor!', classMessage: 'alert-danger', classMessageIcon: '' });
           ModalReProgramacion.hideMessage();
        });
      }
    }
  }
  selectHandleChangeOption(e) {

   if( e.target.name === 'tipoReprogramacion'){
      this.setState({ tipoReprogramacion: e.target.value });
    }else{
      const { options, selectedIndex } = e.target;
      const l = this.state.fromEntrega; // creates the clone of the state
      l[`label${e.target.name}`] = options[selectedIndex].innerHTML;
      this.setState({ fromEntrega: l });
      const a = this.state.fromEntrega; // creates the clone of the state
      a[e.target.name] = e.target.value;
      this.setState({ fromEntrega: a });
    }
 }


  selectHandleChange(e) {
    const { options, selectedIndex } = e.target;
    const l = this.state.fromEntrega; // creates the clone of the state
    l[`label${e.target.name}`] = options[selectedIndex].innerHTML;
    this.setState({ fromEntrega: l });
    const a = this.state.fromEntrega; // creates the clone of the state
    a[e.target.name] = e.target.value;
    this.setState({ fromEntrega: a });
    if (this.state.fromEntrega.codLugEntrega === '2') {
      l.codFilial = '';
      this.setState({ fromEntrega: l });


      this.setState({ muestraLoad: 'block', eventsBlocked: [], disponibilidad: [] });
      const promises = [];
      const objDisponibilidad = [];
      const lista = [];

      const currentWeek = moment().isoWeek();
      //const weekday = moment().weekday();
      const date = [];
      const valueFLOTA = this.props.selectedID.length === 1 ? 'N' : 'S';


      const startOfWeek = moment().isoWeek(currentWeek).startOf('isoWeek');
      const endOfWeek = moment().isoWeek(currentWeek).endOf('isoWeek');
      const days = [];
      let day = startOfWeek;

      while (day <= endOfWeek) {
        days.push(moment(day.toDate()).format('DD/MM/YYYY'));
        day = day.clone().add(1, 'd');
      }


      promises.push(this.props.programacionCalendario('000', '000', '0', valueFLOTA, this.state.fromEntrega.codLugEntrega));
      promises.push(this.props.dias_traslado(
        this.props.selectedID[0].numPedidoVeh,
        this.props.selectedID[0].codCia,
        this.props.selectedID[0].codProv,
        e.target.value));

      promises.push(this.props.listarProgramacionXsede('PR', '000', date[0], date[6]));

      Promise.all(promises)
      .then((results) => {
        if (results[0].payload.data.estadoTrama === '1' &&
        results[1].payload.data.estadoTrama === '1' &&
          results[2].payload.data.estadoTrama === '1'
          ) {
          results[2].payload.data.entrega.forEach((entry) => {
            const lispedido = [];
            lispedido.push({ numPedi: entry.numPedidoVeh, chasis: entry.numChasis });
            const obj = {};
            obj.codPlanEntrVehi = entry.codPlanEntrVehi;

            obj.nomEmpresa = entry.desCliente;
            obj.fechProinicio = moment(entry.fecProgramada).format('DD/MM/YYYY HH:mm');
            obj.fechProfin = moment(entry.fecProgramada).add(entry.numHorEntr, 'hours').format('DD/MM/YYYY HH:mm');
            obj.pedidos = lispedido;
            lista.push(obj);
          });


          objDisponibilidad.push(results[0].payload.data.disponibilidad[0]);

          {// set de variables para calendario
            let numero = 0,
              txt = '',
              info = '',
              plural = '';
            this.state.disponibilidad.forEach((entry) => {
              numero = entry.canMaxiUnidEntr;
              txt = entry.codTipoDiaEntr === 'D' ? 'día' : 'semana';
              plural = entry.canMaxiUnidEntr === '1' ? 'pedido' : 'pedidos';
              info = `Planificación de ${numero} ${plural} por ${txt}.`;
            });
            this.setState({ diasTraslado: results[1].payload.data.codigo, infoCalendario: info });
          }
        } else if (results[0].payload.data.estadoTrama === '-1' ||
        results[1].payload.data.estadoTrama === '-1' ||
        results[2].payload.data.estadoTrama === '-1') {

          this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: '¡Error inesperado, interno del servidor!', classMessage: 'alert-danger', classMessageIcon: '' });
          ModalReProgramacion.hideMessage();
        }else if( results[1].payload.data.estadoTrama ==='0'){

          this.setState({ infoCalendario: '', muestraLoad: 'none', messageShow: 'block', mensajeAlert: results[1].payload.data.mensaje, classMessage: 'alert-info', classMessageIcon: 'ion-information-circled' });
          ModalReProgramacion.hideMessage();

        }
        else if( results[0].payload.data.estadoTrama ==='0'){

          this.setState({ infoCalendario: '', muestraLoad: 'none', messageShow: 'block', mensajeAlert: results[0].payload.data.mensaje, classMessage: 'alert-info', classMessageIcon: 'ion-information-circled' });
          ModalReProgramacion.hideMessage();

        }
         else {
           this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: '¡Error interno del servidor!', classMessage: 'alert-danger', classMessageIcon: '' });
           ModalReProgramacion.hideMessage();
         }
      }).then(() => this.setState({ muestraLoad: 'none', eventsBlocked: lista, disponibilidad: objDisponibilidad })).catch(() => {
         this.setState({ muestraLoad: 'none', messageShow: 'block', mensajeAlert: '¡Error interno del servidor!', classMessage: 'alert-danger', classMessageIcon: '' });
         ModalReProgramacion.hideMessage();
       });
    } else {
      a.codTransp = '1';
      a.labelcodTransp = 'CHOFER DIVEMOTOR';
      this.setState({ fromEntrega: a });
    }
  }


  handleClickValCalendar() {
    this.setState({ estadoStep: this.state.estadoStep + 1 });
  }

  handleClickValFrom() {
    const { fromEntrega} = this.state;

    let sw = true;

    if (     fromEntrega.codTransp.length === 0
          || fromEntrega.nomContacto.length === 0
          || fromEntrega.codEntrega.length === 0
          || fromEntrega.emaContConfi.length === 0
          || fromEntrega.codUsuResp.length === 0
          || this.state.validaEmailConf === true
          || this.state.validaEmail === true
          ) {
      this.setState({ validarCampo: true });
      sw = false;
    } else {
      sw = true;
    }

    if (fromEntrega.codLugEntrega === '2') {
      if (fromEntrega.dirContacto.length === 0) {
        this.setState({ validarCampo: true });
        sw = false;
      } else {
        sw = true;
      }
    }

    if (sw) {
      this.setState({ estadoStep: this.state.estadoStep + 1 });
    }
  }

  changeLugarEntrega(e) {
    this.setState({ valueLugar: e.target.value });
  }

  handleChangeModalClose(value) {
    this.setState({ estadoStep: 0 });
    this.resetState();
    this.props.onClickmodal(true, value);
  }


  renderProformasSelected() {
    return this.state.selected.map(proforma => (
      <li className='pill pill-cyan pillSelct-pills-item' key={proforma.nroProforma}>
        {proforma.nroProforma}
        <button
          type='button'
          className='pillSelct-delete'
          onClick={() => this.unselectProforma({ proforma })}
        >
          <i className='icon ion-close pill-close' />
        </button>
      </li>
    ));
  }

  stepProgramacionMasiva() {
    return (
      <div id='entrega-crea-masivo'>
        <div className='tableWrapper'>
          <table className='table table-hover'>
            <thead className='table-head'>
              <tr>
                <th>N° FDV</th>
                <th>N° Chasis</th>
                <th>N° Pedido</th>
              </tr>
            </thead>
            <tbody>

              {
                this.props.selectedID.map(
                 (Rows, i) => (
                   <tr key={i}>
                     <td>{Rows.numFichaVta}</td>
                     <td>{Rows.numChasis}</td>
                     <td>{Rows.numPedidoVeh}</td>
                   </tr>
                  ))
              }
            </tbody>
          </table>
        </div>

        <div className=' mt-3'>
          <div className='tableWrapper'>
            <table className='table table-hover'>
              <thead className='table-head'>
                <tr>
                  <th>Contacto</th>
                  <th>Teléfono</th>
                  <th>Cargo</th>
                  <th> {true ? <i className='ion-chevron-down ml-3 c-cyan' /> : <i className='ion-chevron-up ml-3 c-cyan' />}                                                      </th>
                </tr>
              </thead>
              <tbody>
                {
                    this.props.contactoCliente.map(o =>
                      <tr>
                        <td>{o.nomContacto}</td>
                        <td>{o.telContacto}</td>
                        <td colSpan='2'>{o.desCargo}</td>
                      </tr>
                    )
                  }
              </tbody>
            </table>
          </div>
        </div>

        <div className='row mt-3'>
          <div className='col-md-4'>
            <div className='form-group'>
              <label className='labelInfo'>Motivo de reprogramación</label>
              <div className='select'>
                <select className='form-control' onChange={this.selectHandleChangeOption} name='tipoReprogramacion' value={this.state.tipoReprogramacion}>
                  <option value=''> -- Selecciona -- </option>
                  {
                    this.props.listaMotivoReprogramacion.map(
                      Rows => (
                        <option value={Rows.codTipo} key={Rows.codTipo}>{Rows.descripcion}</option>
                      ))
                  }
                </select>
                <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
              </div>
            </div>
          </div>
        </div>
        <div className='modal-actions'>
          <button className='btn btn-default pull-left' data-dismiss='modal' onClick={() => this.handleChangeModalClose(true)} >Cancelar</button>
          <button className='btn btn-primary pull-right' hide='#entrega-crea-masivo,#entrega-resumen-unico' show='#entrega-crea-calendario,#entrega-resumen-masivo' onClick={() => this.onClickComenzar()} disabled={!this.state.tipoReprogramacion}>Comenzar</button>
        </div>
      </div>
    );
  }


  printcontent = (content)=>
  {
      return {__html:content};
  }




  stepProgramacion() {
    return (
      <div id='entrega-crea-unico'>
        <div className='modalBleed carCard-sec'>
          <div className='row'>
            <div className='col-md-5'>
              <h2 className='h4 bold'>{ this.props.selectedID[0].nomMarca}</h2>
            </div>
            <div className='col-md-2'>
              <p className='labelInfo'>Nº FDV</p>
              <p>{ this.props.selectedID[0].numFichaVta}</p>
            </div>
            <div className='col-md-3'>
              <p className='labelInfo'>Nº Chasis</p>
              <p>{ this.props.selectedID[0].numChasis}</p>
            </div>
            <div className='col-md-2'>
              <p className='labelInfo'>Nº Pedido</p>
              <p>{this.props.selectedID[0].numPedidoVeh}</p>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <p className='labelInfo'>Propietario</p>
              <p>{this.props.selectedID[0].desCliente}</p>
            </div>
            <div className='col-md-4'>
              <p className='labelInfo'>{this.props.selectedID[0].dni === '' || this.props.selectedID[0].dni === null ? 'RUC' : 'DNI'} </p>
              <p>{this.props.selectedID[0].dni === '' || this.props.selectedID[0].dni === null ? `${this.props.selectedID[0].ruc}` : `${this.props.selectedID[0].dni}`}</p>
            </div>
            <div className='col-md-4'>
              <p className='labelInfo'>Asesor Coomercial </p>
              <p>{this.props.selectedID[0].asesorComercial}</p>
            </div>
            {/* <div className='col-md-4'>
              <p className='labelInfo'>Telefono</p>
              <p>{this.props.selectedID[0].telContRece ? this.props.selectedID[0].telContRece : '-'}</p>
            </div> */}
          </div>
        </div>
        <div className='row mt-3'>
          <div className='col-sm-2'>
            <p className='labelInfo'>Área de venta</p>
            <p>{this.props.selectedID[0].desAreaVta}</p>
          </div>
          <div className='col-sm-2'>
            <p className='labelInfo'>Modelo</p>
            <p>{this.props.selectedID[0].modelo}</p>
          </div>
          <div className='col-sm-2'>
            <p className='labelInfo'>Familia</p>
            <p>{this.props.selectedID[0].desFamiliaVeh}</p>
          </div>
          <div className='col-sm-2'>
            <p className='labelInfo'>Fª C. Comercial</p>
            <p>
              { this.props.selectedID[0].fechaCompEntrega ? moment(this.props.selectedID[0].fechaCompEntrega).format('DD/MM/YYYY') : '-'}
            </p>
          </div>
          <div className='col-sm-2'>
            <p className='labelInfo'>Fª C. Logística</p>
            <p>
              { this.props.selectedID[0].fechaComLog ? moment(this.props.selectedID[0].fechaComLog).format('DD/MM/YYYY') : '-'}
            </p>
          </div>
          <div className='col-sm-2'>
            <p className='labelInfo'>Fª Rec. Placa</p>
            <p>{ this.props.selectedID[0].fecRecepPlaca ? moment(this.props.selectedID[0].fecRecepPlaca).format('DD/MM/YYYY') : '-'}</p>
          </div>

        </div>

        <div className=' mt-3'>
          <div className='tableWrapper'>
            <table className='table table-hover'>
              <thead className='table-head'>
                <tr>
                  <th>Contacto</th>
                  <th>Teléfono</th>
                  <th>Cargo</th>
                </tr>
              </thead>
              <tbody>
                {
                    this.props.contactoCliente.map(o =>
                      <tr>
                        <td>{o.nomContacto}</td>
                        <td>{o.telContacto}</td>
                        <td colSpan='2'>{o.desCargo}</td>
                      </tr>
                    )
                  }
              </tbody>
            </table>
          </div>
        </div>

        <div className='row mt-3'>
          <div className='col-md-4'>
            <div className='form-group'>
              <label className='labelInfo'>Motivo de reprogramación</label>
              <div className='select'>
                <select className='form-control' onChange={this.selectHandleChangeOption} name='tipoReprogramacion' value={this.state.fromEntrega.tipoReprogramacion}>
                  <option value=''> -- Selecciona -- </option>
                  {
                    this.props.listaMotivoReprogramacion.map(
                      Rows => (
                        <option value={Rows.codTipo} key={Rows.codTipo}>{Rows.descripcion}</option>
                      ))
                  }
                </select>
                <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
              </div>
            </div>
          </div>
        </div>

        <div className='modal-actions'>
          <button className='btn btn-default pull-left' data-dismiss='modal' onClick={() => this.handleChangeModalClose(true)} >Cancelar</button>
          <button className='btn btn-primary pull-right' hide='#entrega-crea-unico,#entrega-resumen-masivo' show='#entrega-crea-calendario,#entrega-resumen-unico' onClick={() => this.onClickComenzar()} disabled={!this.state.tipoReprogramacion}>Comenzar</button>
        </div>
      </div>
    );
  }

  renderCalendar(week, month, date) {
    let valRechazo = 0;
    let newdiasTraslado = 0;
    let valueHoraCorte = '';

   // validar pedidos rechazados
   console.log('LISTA PEDIDOS' + this.props.selectedID);
   this.props.selectedID.forEach((entry) => {
     console.log(entry.estaPlan);

     if (entry.estaPlan === 'RECHAZADO') {
       console.log(entry.estaPlan);
       valRechazo++;
     }
   });


   if (valRechazo === this.props.selectedID.length) {
     newdiasTraslado = 1;
     valueHoraCorte = 'false';

   } else {
     newdiasTraslado = this.state.diasTraslado;
     valueHoraCorte = this.state.valueHoraCorte
   }

   var fecha1 = moment(moment(),'DD/MM/YYYY HH:mm').add(newdiasTraslado, 'days')
   var fecha2 = moment(this.props.currentEvent[0].fechProfin,'DD/MM/YYYY HH:mm');

   console.log('Diferencia Dias',fecha1.diff(fecha2, 'days'));
   console.log('Diferencia horas',fecha1.diff(fecha2, 'hours'))
   if(fecha1.diff(fecha2, 'days')>=0 && fecha1.diff(fecha2, 'hours')>=0){
    newdiasTraslado = 0;
   }



    if (this.state.disponibilidad.length > 0 && this.state.disponibilidad[0] !== undefined && this.state.fromEntrega.codLugEntrega === '1') {


      return (
        <div>
          <Calendar
            horaInicio={moment(this.state.disponibilidad[0].horaIniEntr).format('HH:mm')}
            horaFinal={moment(this.state.disponibilidad[0].horaMaxEntr).format('HH:mm')}
            horaExcepcion={[moment(this.state.disponibilidad[0].horaIniLocked).format('HH:mm').substring(0, 5),
              moment(this.state.disponibilidad[0].horaFinLocked).format('HH:mm').substring(0, 5)]}
            asignacionFutura={newdiasTraslado}
            rangoHora={this.state.disponibilidad[0].numHorasReservada}
            eventosProgramados={this.state.eventsBlocked}
            slots={this.state.disponibilidad[0].canVehiParalelo}

          // eventsBlocked={eventsBlocked}
          // events={events}
            updateParent={this.updateParent}
            weekday={this.state.weekday}
            week={week}
            date={date}
            month={month}
            currentEvent={this.state.currentEvent}
            feriados={[]}
            maxEntregas={this.state.disponibilidad[0].canMaxiUnidEntr}
            maxEntregasTipo={this.state.disponibilidad[0].codTipoDiaEntr}
            lstAdicionales={this.state.lstAdicionales}
            valueHoraCorte = {valueHoraCorte}
            sabado = {this.state.disponibilidad[0].sabado}
            domingo = {this.state.disponibilidad[0].domingo}
            fecComercialReprog={this.props.selectedID[0].fechaCompEntrega}
          />
        </div>
      );
    } else if (this.state.disponibilidad.length > 0 && this.state.disponibilidad[0] !== undefined && this.state.fromEntrega.codLugEntrega === '2') {
      return (
        <div>
          <Calendar
            horaInicio={moment(this.state.disponibilidad[0].horaIniEntr).format('HH:mm')}
            horaFinal={moment(this.state.disponibilidad[0].horaMaxEntr).format('HH:mm')}
            horaExcepcion={[moment(this.state.disponibilidad[0].horaIniLocked).format('HH:mm').substring(0, 5),
              moment(this.state.disponibilidad[0].horaFinLocked).format('HH:mm').substring(0, 5)]}
            asignacionFutura={newdiasTraslado}
            rangoHora={this.state.disponibilidad[0].numHorasReservada}
            eventosProgramados={this.state.eventsBlocked}
            slots={this.props.selectedID.length}

          // eventsBlocked={eventsBlocked}
          // events={events}
            updateParent={this.updateParent}
            weekday={this.state.weekday}
            week={week}
            date={date}
            month={month}
            currentEvent={this.state.currentEvent}
            feriados={[]}
            maxEntregas={this.state.disponibilidad[0].canMaxiUnidDisp}
            maxEntregasTipo={this.state.disponibilidad[0].codTipoDiaEntr}
            lstAdicionales={this.state.lstAdicionales}
            valueHoraCorte = {valueHoraCorte}
            sabado = {this.state.disponibilidad[0].sabado}
            domingo = {this.state.disponibilidad[0].domingo}
            fecComercialReprog={this.props.selectedID[0].fechaCompEntrega}
          />
        </div>
      );
    }
    return (

      <div>
        <Calendar
          horaInicio={'09:00'}
          horaFinal={'18:00'}
          horaExcepcion={['12:00', '12:30']}
          asignacionFutura={0}
          rangoHora={1}
          eventosProgramados={[]}
          slots={2}

              // eventsBlocked={eventsBlocked}
              // events={events}
          updateParent={this.updateParent}
          weekday={this.state.weekday}
          week={week}
          date={date}
          month={month}
          currentEvent={this.state.currentEvent}
          feriados={[]}
          maxEntregas={2}
          maxEntregasTipo='dia' // dia o semana
          disabled
          valueHoraCorte = {valueHoraCorte}
          fecComercialReprog={this.props.selectedID[0].fechaCompEntrega}
        />
      </div>
    );
  }


  stepAgendar() {
    const { currentWeek,currentSetYear } = this.state;


    const castDate = moment({year: moment(currentSetYear).format('YYYY'), month: 1, day: 1, hour: 0});
    const  month = moment(castDate).isoWeek(currentWeek).startOf('isoWeek').format('MMMM - YYYY');
    const  startOfWeek = moment(castDate).isoWeek(currentWeek).startOf('isoWeek');
    const  endOfWeek = moment(castDate).isoWeek(currentWeek).endOf('isoWeek');

    const week = [];
    const date = [];
    let day = startOfWeek;

    while (day <= endOfWeek) {
      date.push(moment(day.toDate()).format('DD/MM/YYYY'));
      week.push(moment(day.toDate()).format('DD/MM'));
      day = day.clone().add(1, 'd');
    }

    return (
      <div id='entrega-crea-calendario'>

        <div className='row mt-3'>
        <div className='col-md-2'>
          <div className='form-group'>
              <label className='labelInfo'>Ubicación actual</label>
              <div className='select'>
                <p className='h6' >{this.props.selectedID[0].descNomFilial}</p>
              </div>
            </div>
          </div>
          <div className='col-md-3'>
            <div className='form-group'>
              <label className='labelInfo'>Lugar de entrega</label>
              <div className='select'>
                <select className='form-control' onChange={this.selectHandleChange} name='codLugEntrega' value={this.state.fromEntrega.codLugEntrega}>
                  <option value=''> -- Selecciona -- </option>
                  {
                    this.props.estadoGeneralLugarEntrega.map(
                      Rows => (
                        <option value={Rows.codTipo} key={Rows.codTipo}>{Rows.descripcion}</option>
                      ))
                  }
                </select>
                <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
              </div>
            </div>
          </div>
          <div className='col-md-3'>
            <div className={`form-group ${(this.state.fromEntrega.codLugEntrega === '2' || this.state.fromEntrega.codLugEntrega === '') ? 'js-hide' : ''}`}>
              <label className='labelInfo'>Sede
                                            </label>
              <div className='select'>

                <select className='form-control' name='codFilial' value={this.state.fromEntrega.codFilial} onChange={this.handleChange}>
                  <option value=''>-- Selecciona --</option>
                  {
                    this.props.listaentregaFilial.map(
                      Rows => (
                        <option value={Rows.id} key={Rows.id}>{Rows.nombre}</option>
                      ))
                  }
                </select>

                <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
              </div>
            </div>
          </div>

          <div className='col-md-3'>
              {
                this.state.fromEntrega.codLugEntrega === '1' || this.state.fromEntrega.codLugEntrega === '2'  ?
                ( <div className='pag-arrows mt-3 mb-3 pull-right' style={{marginTop:'24px'}}>
                      <a className='btn btn-default pag-link mr-2'  onClick={() => this.today()}>Hoy</a>
                      <a className='btn btn-default pag-link' onClick={() => this.back()}><i className='ion-chevron-left' /></a>
                      <a className='btn btn-default pag-link'   onClick={() => this.next()}><i className='ion-chevron-right' /></a>
                      <input className='form-control' type='hidden' value={date[0]} id='fechaInicio' />
                      <input className='form-control' type='hidden' value={date[6]} id='fechaFinal' />
                 </div>
              ):(null)
              }
          </div>
        </div>
        <div className='row mt-3'>
          <div className='col-md-10'>
            <p>
              {this.state.infoCalendario}
            </p>
          </div>
        </div>
        {
          this.renderCalendar(week, month, date)
        }
        <div className='modal-actions'>
          <button className='btn btn-default pull-left' onClick={() => this.onClickPreviousPage()}>Volver</button>
          <button
            className='btn btn-primary pull-right'
            onClick={() => this.onClickNextPage()}
            disabled={!((!this.state.validaFecha ) && (this.state.fromEntrega.codLugEntrega === '2' || (this.state.fromEntrega.codLugEntrega === '1' && this.state.fromEntrega.codFilial !== '')))}

          >Continuar
          </button>
        </div>
      </div>
    );
  }

  replaceTexto = (texto)=>{
     if(texto !== undefined ){
       if( texto !== null){
       if(texto.length > 0){
        return texto.replace(/<br\s?\/?>/g,"\n");
       }
      }
     }
    return texto;
  }

  stepEntrega() {
    const { fromEntrega } = this.state;

    return (
      <div>
        <h3 className='h5 bold'>Datos del cliente</h3>
        <div className='row'>
          <div className='col-sm-6'>
            <div className='form-group'>
              <label className='labelInfo'>Contacto recepción (*)
                   </label>
              <input className='form-control' type='text' value={fromEntrega.nomContacto} name='nomContacto' onChange={this.handleChange} />
              <span className='error' style={{ display: (fromEntrega.nomContacto.length === 0 && this.state.validarCampo === true) ? 'block' : 'none' }}>Introduce un Contacto recepción</span>

            </div>
            <div className='form-group'>
              <label className='labelInfo'>Email contacto
                   </label>
              <input
                className='form-control' type='email' id='email' value={fromEntrega.emaContacto} name='emaContacto' onChange={this.handleChange}

              />
              <span className='error' style={{ display: (this.state.validaEmail && this.state.validarCampo === true)? 'block' : 'none'  }}>Formato incorrecto (mail@example.com ó mail@example.com.pe)</span>
              </div>
            <div className='form-group'>
              <div className='form-group'>
                <label className='labelInfo'>Observaciones</label>
                <textarea className='form-control' value={this.replaceTexto(fromEntrega.obsContacto)} name='obsContacto' onChange={this.handleChange} />
              </div>
            </div>
          </div>
          <div className='col-sm-6'>
            <div className='form-group'>
              <label className='labelInfo'>Teléfono contacto
                   </label>
              <input className='form-control' type='text' value={fromEntrega.telContacto} name='telContacto' onChange={this.handleChange} />
            </div>
            <div className={`form-group ${(fromEntrega.codLugEntrega === '2') ? '' : 'js-hide'}`}>
              <label className='labelInfo'>Dirección de entrega (*)
                   </label>
              <input className='form-control' type='text' value={fromEntrega.dirContacto} name='dirContacto' onChange={this.handleChange} />
              <span className='error' style={{ display: (fromEntrega.dirContacto.length === 0 && this.state.validarCampo === true) ? 'block' : 'none' }}>Introduce una dirección de entrega</span>
            </div>

            <div className='form-group'>
              <label className='labelInfo'>Correo de confirmación (*) </label>
              <input
                className='form-control' type='email' id='email' value={fromEntrega.emaContConfi} name='emaContConfi' onChange={this.handleChange}

              />
               <span className='error' style={{ display: (this.state.validaEmailConf  && this.state.validarCampo === true)? 'block' : 'none' }}>Formato incorrecto (mail@example.com ó mail@example.com.pe)</span>
               <span className='error' style={{ display: (fromEntrega.emaContConfi.length === 0 && this.state.validarCampo === true) ? 'block' : 'none' }}>Introduce un contacto de confirmación</span>
            </div>


          </div>
        </div>
        <hr className='modalBleed' />
        <h3 className='h5 bold'>Datos de Divemotor</h3>
        <div className='row'>
          <div className='col-sm-6'>
            <div className='form-group'>
              <label className='labelInfo'>Conductor al destino del cliente (*)
                   </label>

                   {
                  fromEntrega.codLugEntrega === '1'?(
                                   <div className='select'>
                                      <select className='form-control' value={2} name='codTransp' onChange={this.selectHandleChangeOption} disabled={true}>
                                        <option value=''>-- Selecciona --</option>
                                        {
                                          this.props.estadoGeneralTransportista.map(
                                            Rows => (
                                              <option value={Rows.codTipo} key={Rows.codTipo} >{Rows.descripcion}</option>
                                            ))
                                        }
                      </select>
                      <div className='select-control-icon'><i className='ion-arrow-down-b' />
                      </div>
                    </div>
                             ) : (
                               <div className='select'>
                                 <select className='form-control' value={fromEntrega.codTransp} name='codTransp' onChange={this.selectHandleChangeOption}>
                                   <option value=''>-- Selecciona --</option>

                                   {
                                          this.props.estadoGeneralTransportista.map(
                                            Rows => (
                                              <option value={Rows.codTipo} key={Rows.codTipo} >{Rows.descripcion}</option>
                                            ))
                                        }
                                 </select>
                                 <div className='select-control-icon'><i className='ion-arrow-down-b' />
                                 </div>

                               </div>
                  )
                }

              <span className='error' style={{ display: (fromEntrega.codTransp.length === 0 && this.state.validarCampo === true) ? 'block' : 'none' }}>Selecciona un Transportista</span>
              <div className='form-group'>
                <div className='pillSelct'>
                  <p className='labelInfo'>Especialista de entrega (*)</p>
                  <div className='select'>
                    <select className='form-control' value={fromEntrega.codUsuResp} name='codUsuResp' onChange={this.selectHandleChangeOption}>
                      <option value=''>-- Selecciona --</option>
                      {
                      this.state.listItemsUsu.map(
                        Rows => (
                          <option value={Rows.idUsuario} key={Rows.idUsuario} >{Rows.dataNombres}</option>
                        ))
                    }
                    </select>
                    <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                    <span className='error' style={{ display: (fromEntrega.codUsuResp.length === 0 && this.state.validarCampo === true) ? 'block' : 'none' }}>Introduce un especialista de entrega</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-sm-6'>
            <label className='labelInfo'>Tipo de entrega (*)
                                </label>
            <div className='select'>

              <select className='form-control' value={fromEntrega.codEntrega} name='codEntrega' onChange={this.selectHandleChangeOption}>
                <option value=''>-- Selecciona --</option>

                {
                  this.props.estadoGeneralTipoEntrega.map(
                    Rows => (
                      <option value={Rows.codTipo} key={Rows.codTipo} >{Rows.descripcion}</option>
                    ))
                }
              </select>
              <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
            </div>

            <span className='error' style={{ display: (fromEntrega.codEntrega.length === 0 && this.state.validarCampo === true) ? 'block' : 'none' }}>Selecciona un tipo de entrega</span>


            <div className='form-group'>
              <div className='pillSelct'>
                <p className='labelInfo'>Personal adicional</p>
                <div className='pillSelct-field'>

                  <Autocomplete
                    getItemValue={item => item.idUsuario.toString()}
                    items={this.props.colaboradores}
                    renderItem={(item, isHighlighted) =>
                      <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                        {`${item.apellidos} ${item.nombre}`}
                      </div>
                    }
                    onChange={(e) => {
                      if (e.target.value.length >= 2) {
                        this.props.fetchColaboradores(e.target.value);
                      }
                      if (e.target.value.length === 0) {
                        this.props.clearColaboradores();
                      }
                      this.setState({ itempersonalAd: e.target.value });
                    }}
                    value={this.state.itempersonalAd}
                    autoHighlight={this.state.trueComplete}
                    onSelect={(key) => {
                      const name = this.props.colaboradores
                                    .filter(({ idUsuario }) =>
                                      idUsuario.toString() === key)[0].nombre;

                      const apellidos = this.props.colaboradores
                                    .filter(({ idUsuario }) =>
                                      idUsuario.toString() === key)[0].apellidos;
                      const varpersona = { id: key, apellido: `${apellidos} ${name}` };


                      if (!(this.state.listItemsPe.indexOf(varpersona)>=0)) {
                        this.setState({
                          listItemsPe: [...this.state.listItemsPe, varpersona],
                          itempersonalAd: '',
                        });
                      }
                      this.props.clearColaboradores();
                    }}
                    menuStyle={{
                      position: 'absolute',
                      left: '0',
                      top: '100%',
                      maxHeight: '350px',
                      overflow: 'auto',
                      border: '1px solid #cccccc',
                    }}
                    inputProps={{
                      className: 'form-control awesomplete pillSelct-input',
                    }}
                    wrapperStyle={{
                      position: 'relative',
                      zIndex: '10',
                    }}
                  />


                </div>
                <div className='pillSelct-pills' >
                  {
                    this.state.listItemsPe.map(Rows => (
                      <label className='pill pill-cyan pillSelct-pills-item'>{Rows.apellido}
                        <button
                          className='pillSelct-delete'
                          onClick={() => {
                            this.setState({
                              listItemsPe: this.state.listItemsPe.filter(x => x !== Rows),
                            });
                          }}
                        ><i className='icon ion-close pill-close' />
                        </button>
                      </label>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-sm-6'>
            <div className='form-group'>
              <label className='labelInfo'>Tipo de placa</label>
              <div className='row'>
                <div className='col-md-4'>
                  <div className='radio'>
                    <label className='radio-label'>
                      <input type='radio' name='tipPlaca' value='1' checked={fromEntrega.tipPlaca === '1'} onChange={this.handleChange} />
                      <div className='radio-skin' />Definitiva
                     </label>
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className='radio'>
                    <label className='radio-label'>
                      <input type='radio' name='tipPlaca' value='2' checked={fromEntrega.tipPlaca === '2'} onChange={this.handleChange} />
                      <div className='radio-skin' />Rotativa
                     </label>
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className='radio'>
                    <label className='radio-label'>
                      <input type='radio' name='tipPlaca' value='3' checked={fromEntrega.tipPlaca === '3'} onChange={this.handleChange} />
                      <div className='radio-skin' />Sin placa
                     </label>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div className='modal-actions'>
          <button className='btn btn-default pull-left' onClick={() => this.onClickPreviousPage()}>Volver</button>
          <button className='btn btn-primary pull-right' onClick={() => this.handleClickValFrom()}>Continuar</button>
        </div>
      </div>
    );
  }

  stepConfirmar() {
    return (
      <div>
        <div className='card card-lg card-plain mb-3' id='entrega-resumen-unico'>
          <div className='row'>
            <div className='col-md-3'>
              <h3 className='h6'><span className='bold'>{ this.props.selectedID[0].nomMarca}</span><br /><span>A 180 - 2017</span></h3>
            </div>
            <div className='col-md-3'>
              <label className='labelInfo'>N° FDV
               </label>
              <p>{ this.props.selectedID[0].numFichaVta}</p>
            </div>
            <div className='col-md-3'>
              <label className='labelInfo'>N° Chasis
               </label>
              <p>{ this.props.selectedID[0].numChasis}</p>
            </div>
            <div className='col-md-3'>
              <label className='labelInfo'>N° Pedido
               </label>
              <p>{this.props.selectedID[0].numPedidoVeh}</p>
            </div>
          </div>
          <hr />
          <div className='row'>
            <div className='col-md-2'>
              <label className='labelInfo'>Àrea de venta
               </label>
              <p>{this.props.selectedID[0].desAreaVta}</p>
            </div>
            <div className='col-md-2'>
              <label className='labelInfo'>Familia
               </label>
              <p>{this.props.selectedID[0].desFamiliaVeh}</p>
            </div>
            <div className='col-md-2'>
              <label className='labelInfo'>F° C° Comercial
               </label>
              <p>
                { this.props.selectedID[0].fechaCompEntrega ? moment(this.props.selectedID[0].fechaCompEntrega).format('DD/MM/YYYY') : '-'}
              </p>
            </div>
            <div className='col-md-2'>
              <label className='labelInfo'>F° Rec. Placa
               </label>
              <p>
                { this.props.selectedID[0].fecRecepPlaca ? moment(this.props.selectedID[0].fecRecepPlaca).format('DD/MM/YYYY') : '-'}
              </p>
            </div>
            <div className='col-md-2'>
              <label className='labelInfo'>F° Rep. Comercial
               </label>
              <p>
                { this.props.selectedID[0].fechaRepComercial ? moment(this.props.selectedID[0].fechaRepComercial).format('DD/MM/YYYY') : '-'}</p>
            </div>
          </div>
        </div>
        <div className={`tableWrapper mb-3 ${this.props.selectedID.length > 0 ? 'js-hide' : ''}`} id='entrega-resumen-masivo' >
          <table className='table table-hover'>
            <thead className='table-head'>
              <tr>
                <th>N° FDV</th>
                <th>N° Chasis</th>
                <th>N° Pedido</th>
              </tr>
            </thead>
            <tbody>
              {
                this.props.selectedID.map(
                  Rows => (
                    <tr>
                      <td>{Rows.numFichaVta}</td>
                      <td>{Rows.numChasis}</td>
                      <td>{Rows.numPedidoVeh}</td>
                    </tr>
                  ))
              }
            </tbody>
          </table>
        </div>
        <div className='card card-lg card-plain mb-3'>
          <div className='row'>
            <div className='col-md-4'>
              <label className='labelInfo'>Transportista
               </label>
              <p>{this.state.fromEntrega.labelcodTransp}</p>
            </div>
            <div className='col-md-4'>
              <label className='labelInfo'>Tipo de entrega
               </label>
              <p>{this.state.fromEntrega.labelcodEntrega}</p>
            </div>
            <div className='col-md-4'>
              <label className='labelInfo'>Especialista de entrega
               </label>
              <p>{ this.state.listItemsUsu.filter(({ idUsuario }) => (idUsuario === this.state.fromEntrega.codUsuResp))[0].nombre }</p>

            </div>
          </div>
          <div className='row'>
            <div className='col-md-8'>
              <label className='labelInfo'>Personal adicional
               </label>
              {
                  this.state.listItemsPe.map(Rows => (
                    <p>{Rows.apellido}</p>
                  ))
                }
            </div>
          </div>
        </div>
        <div className='card card-lg card-plain'>
          <div className='row'>
            <div className='col-md-4'>
              <label className='labelInfo'>Lugar de entrega
               </label>
              <p>{this.state.fromEntrega.labelcodLugEntrega}</p>
            </div>
            <div className='col-md-4'>
              <label className='labelInfo'>Dirección de entrega
               </label>
              <p>{this.state.fromEntrega.dirContacto}</p>
            </div>
            <div className='col-md-4'>
              <label className='labelInfo'>Fecha de entrega
               </label>
              <p>{this.state.newProgramacion}</p>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <label className='labelInfo'>Contacto recepción
               </label>
              <p>{this.state.fromEntrega.nomContacto}</p>
            </div>
            <div className='col-md-4'>
              <label className='labelInfo'>Teléfono
               </label>
              <p>{this.state.fromEntrega.telContacto}</p>
            </div>
            <div className='col-md-4'>
              <label className='labelInfo'>Email
               </label>
               {
                 this.state.fromEntrega.emaContacto !== null?(
                  this.state.fromEntrega.emaContacto.split(',').map(a => (
                    <p>{a}</p>
                   )
                  )
                 ):(null)
               }
            </div>
            <div className='col-xs-12'>
              <label className='labelInfo'>Observaciones
               </label>
              <p dangerouslySetInnerHTML={this.printcontent(this.state.fromEntrega.obsContacto)}></p>

            </div>
          </div>
        </div>
        <div className='modal-actions'>
          <button className='btn btn-default pull-left' onClick={() => this.onClickPreviousPage()}>Volver</button>
          <button className='btn btn-primary pull-right' onClick={() => this.onClickConfirmar()}>Confirmar programación</button>
        </div>
      </div>
    );
  }

  stepNavegacion() {
    if (this.state.estadoStep === 0 && this.props.selectedID.length > 1) {
      return this.stepProgramacionMasiva();
    } else if (this.state.estadoStep === 0 && this.props.selectedID.length === 1) {
      return this.stepProgramacion();
    } else if (this.state.estadoStep === 1) {
      return this.stepAgendar();
    } else if (this.state.estadoStep === 2) {
      return this.stepEntrega();
    } else if (this.state.estadoStep === 3) {
      return this.stepConfirmar();
    }
  }


  render() {
    return (
      <div>
        <div className={`modal entrNew ${this.props.btnProgramar}`} id='entrega-nueva' role='dialog' data-backdrop='static'>
          <div className='modal-dialog modal-lg' role='document'>
            <button className='btn btn-sm btn-blue modal-close' data-dismiss='modal' onClick={() => this.handleChangeModalClose(true)} >Cerrar ventana</button>
            <div className='modal-content'>
              <div className='modal-body'>
                <h2 className='modal-title'>Reprogramar entrega</h2>
                <div className='modalBleed'>
                  <ol className='progresStep'>
                    <li className={` progresStep-item ${this.state.estadoStep === 1 || this.state.estadoStep === 0 ? 'active' : ''}`} >
                      <div className='progresStep-item-circle'><span className='progresStep-index'>1</span><i className='progresStep-check ion-checkmark' /></div>
                      <p>Agendar fecha</p>
                    </li>
                    <li className={` progresStep-item ${this.state.estadoStep === 2 ? 'active' : ''}`}>
                      <div className='progresStep-item-circle'><span className='progresStep-index'>2</span><i className='progresStep-check ion-checkmark' /></div>
                      <p>Información de entrega</p>
                    </li>
                    <li className={` progresStep-item ${this.state.estadoStep === 3 ? 'active' : ''}`} >
                      <div className='progresStep-item-circle'><span className='progresStep-index'>3</span><i className='progresStep-check ion-checkmark' /></div>
                      <p>Confirmar</p>
                    </li>
                  </ol>
                </div>
                <div className='entrNew-slides'>
                  <div className='simpleSlide active' >
                    {
                    this.stepNavegacion()
                  }

                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className='modal extraFilter' role='dialog' data-backdrop='static' style={{ display: this.state.muestraLoad }} >
            <div className='modal-dialog modal-sm' role='document'>
              <FadeLoader color={'#F8A14A'} loading />
            </div>
          </div>


          <div className={`alert  ${this.state.classMessage}`} role='alert' id='ModalreProgramacionMessages' style={{ display: this.state.messageShow, position: "fixed", zIndex: "2000" }}>
            <i className={this.state.classMessageIcon} />
            <p>{this.state.mensajeAlert}</p>
          </div>

          <div className='modal' id='confirmar-reprogramacion' role='dialog' data-backdrop='static' style={{ display: this.state.btnconfirmar }}>
            <div className='modal-dialog' role='document'>
              <button className='btn btn-sm btn-blue modal-close' data-dismiss='modal' onClick={() => this.onClickbtnConfirmar()}>Cerrar ventana</button>
              <div className='modal-content'>
                <div className='modal-body'>
                  <h2 className='modal-title'>Confirmar reprogramación</h2>
                  <p className='h6 text-center'>Se cancelará la programación previa ¿Estás seguro que deseas reprogramar?</p>
                  <div className='modal-actions'>
                    <button className='btn btn-default' data-dismiss='modal' onClick={() => this.onClickbtnConfirmar()}>Volver</button>
                    <button className='btn btn-primary pull-right' data-dismiss='modal' entrnewslide='next' onClick={this.onClickbtnNext}>Confirmar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    estadoGeneralTransportista: state.estadoGeneralTransportista,
    estadoGeneralLugarEntrega: state.estadoGeneralLugarEntrega,
    estadoGeneralTipoEntrega: state.estadoGeneralTipoEntrega,
    colaboradores: state.colaboradores,
    filiales: state.filiales,
    planificar: state.planificar,
    replanificar: state.replanificar,
    Adpersonas: state.Adpersonas,
    listaentregaFilial: state.listaentregaFilial,
    listaProgramacion: state.listaProgramacion,

  };
}

ModalReProgramacion.defaultProps = {
  estadoGeneralTransportista: [],
  estadoGeneralLugarEntrega: [],
  estadoGeneralTipoEntrega: [],
  colaboradores: [],
  filiales: [],
  planificar: [],
  replanificar: [],
  Adpersonas: [],
  listaentregaFilial: [],
  listaProgramacion: [],
  listaCalendario: [],

};
export default connect(mapStateToProps,
  { fetchEstadoGeneralTransp,
    fetchEstadoGeneralLugarEntrega,
    fetchEstadoGeneralTipoEntrega,
    entregaFilial,
    fetchColaboradores,
    clearColaboradores,
    programarPlanificacion,
    reProgramarPlanificacion,
    personasAdicionales,
    listarProgramacionXsede,
    programacionCalendario,
    dias_traslado,
  })(ModalReProgramacion);



// WEBPACK FOOTER //
// ./src/components/FichaEntrega/ModalReprogramacion.js